<template>
  <div id="Approve">
    <div class="login-page">
      <transition name="fade">
        <div v-if="!status" class="wallpaper-login"></div>
      </transition>
      <div class="wallpaper-register"></div>

      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-8 mx-auto">
            <div id="login-card" class="card login" v-if="!status">
              <h1>APPROVE</h1>
              <!-- <h4 class="">รายละเอียดการจอง</h4> -->
              <!-- histories -->
              <div
                class="text-left"
                v-for="(item, index) in histories"
                :key="index"
              >
                <span>
                  ห้องที่จอง :{{ item.room_name }} 
                </span>
                <br />
                <span> ชื่อผู้จอง : {{ item.whois_std_name }} </span>
                <br />
                <span> วัตถุประสงค์ : {{ item.usefor_name }} </span>
                <br />
                <span>
                  เวลาจอง : {{ item.time_begin }} - {{ item.time_end }}
                </span>
              </div>
              <br />
              <button
                id="button"
                @click="approve()"
                class="btn btn-outline-success deep-purple btn-block"
              >
                อนุมัติ
              </button>
            </div>

            <div id="locker-card" class="card login" v-if="status">
              <!-- {{ status }} -->
              <span v-if="!status_success">
                <h4 class="text-left" v-if="!isShowstaff">
                  <span v-if="statusmes">
                    {{ message }}
                  </span>
                </h4>
                <h4 v-if="!isShowstaff && !statusmes">STAFF ONLY</h4>

                <h4 v-if="auth === null || auth === ''">
                  เข้าสู่ระบบเพื่อใช้งาน
                </h4>

                <router-link
                  v-if="auth === null || auth === ''"
                  to="/login"
                  class="btn btn-success"
                >
                  เข้าสู่ระบบ
                </router-link>
              </span>

              <span v-if="status_success">
                <h4>อนุมัติเรียบร้อย</h4>
                <img
                  src="../../assets/icons/success.gif"
                  class="rounded mx-auto d-block"
                  alt=""
                  width="60%"
                  height="auto"
                />
                <router-link
                  to="/staffMeeting"
                  class="btn btn-outline-info badge-pill"
                  size="lg"
                >
                  เสร็จสิ้น
                </router-link>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Approve",
  data() {
    return {
      std_code: "",
      order_token: "",
      tokenjong: "NDMyMTNDNUYtRkZFNy00NjI1LUIwNTQtMkQ0QTkzOTIyQTM3",
      status: false,
      password: "",
      histories: [],
      staff: "",
      isShowstaff: false,
      auth: "",
      status_success: false,
      message: "",
      statusmes: false,
    };
  },
  mounted() {
    if (localStorage.getItem("auth") != null) {
      this.user = false;
      this.auth = JSON.parse(localStorage.getItem("auth"));
      this.std_code = this.auth.std_code;

      if (this.auth.isLibraryStaff === 1 || this.auth.user_type === "Staff") {
        this.status = false;
        this.status_success = true;
      } else {
        this.status = true;
        this.status_success = false;
      }
    }

    this.order_token = this.$route.params.id;
    this.getBookingroom();
  },
  methods: {
    // api/booking/get_locker_passcode
    getBookingroom() {
      let data = {
        order_token: this.order_token,
      };
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.$isLoading(true);
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/room/get_booking_room",
          data,
          {
            headers,
          }
        )
        .then((res) => {
          if (res.data.msg.status !== 200) {
            this.message = res.data.msg.message;
            if (
              this.auth.isLibraryStaff === 1 ||
              this.auth.user_type === "Staff"
            ) {
              this.status = true;
              this.status_success = false;
              this.statusmes = true;
            } else {
              this.status = true;
              this.status_success = false;
              this.statusmes = false;
            }

            this.$isLoading(false);
          } else {
            this.histories = res.data.histories;
            if (
              this.auth.isLibraryStaff === 1 ||
              this.auth.user_type === "Staff"
            ) {
              this.status = false;
              this.status_success = true;
            } else {
              this.status = true;
              this.status_success = false;
            }
            this.$isLoading(false);
          }
        });
    },
    approve() {
      let data = {
        order_token: this.order_token,
        staff_code: this.std_code,
      };
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/room/approve ", data, {
          headers,
        })
        .then((res) => {
          if (res.data.msg.status !== 200) {
            this.message = res.data.msg.message;
            this.status = true;
            this.$isLoading(false);
          } else {
            this.status = true;
            this.status_success = true;
            this.$isLoading(false);
          }
        });
    },
  },
};
</script>

<style scoped>
#button {
  border-radius: 30px;
}

.input-style {
  border-radius: 30px;
  background-color: #ebf0fc;
  border-color: #ebf0fc;
  color: #9da3b0;
}
#login-card {
  width: 350px;
  border-radius: 25px;
  margin: 150px auto;
}
#locker-card {
  width: 350px;
  border-radius: 25px;
  margin: 150px auto;
}
#regis-card {
  width: 350px;
  border-radius: 25px;
  margin: 150px auto;
}

p {
  line-height: 1rem;
}

.card {
  padding: 20px;
}

.form-group input {
  margin-bottom: 20px;
}
.form-group button {
  margin-bottom: 20px;
}

.login-page {
  align-items: center;
  display: flex;
  height: 100vh;
}
.login-page .wallpaper-login {
  /* background: url(https://www.solidbackgrounds.com/images/2732x2732/2732x2732-dark-pastel-purple-solid-color-background.jpg)
    no-repeat center center; */
  background: -webkit-linear-gradient(-55deg, #754bd4 40%, #2ba3be 100%)
    no-repeat center center;
  background-size: cover;
  height: 100%;
  position: absolute;
  width: 100%;
}

.login-page .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.wallpaper-register {
  /* background: url(https://www.solidbackgrounds.com/images/2732x2732/2732x2732-dark-pastel-purple-solid-color-background.jpg)
    no-repeat center center; */
  background-size: cover;
  background: -webkit-linear-gradient(-55deg, #2ba3be 40%, #754bd4 100%)
    no-repeat center center;
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: -1;
}

h1 {
  margin-bottom: 1.5rem;
}

.error {
  animation-name: errorShake;
  animation-duration: 0.3s;
}

@keyframes errorShake {
  0% {
    transform: translateX(-25px);
  }
  25% {
    transform: translateX(25px);
  }
  50% {
    transform: translateX(-25px);
  }
  75% {
    transform: translateX(25px);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
